import React from "react";
import { useDispatch } from "react-redux";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";
import { useApplicationState, useQueryParams } from "../state/store/customHooks";
import { ONBOARDING_VERSION_1_0, URI_PATHS } from "../constants";

/* Components */
import Onboarding from "../components/onboarding/Onboarding";
import OnboardingV2 from "../components/onboardingV2/onboarding/OnboardingV2";
import PrivateRoute from "../components/onboardingV2/wrappers/auth/PrivateRoute";
import LoginV2 from "../components/onboardingV2/login/LoginV2";
import BasicInfoV2 from "../components/onboardingV2/basicInfo/BasicInfoV2";
import MockDashboard from "../components/onboardingV2/mockDashboard/MockDashboard";
import decode from 'jwt-decode';
import RelinkBank from "../components/onboardingV2/linkBank/RelinkBank";
import { initiateOnboardingConfig } from '../state/actions/application';

const RegistrationRoutes = () => {
  // actions
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const queryParams = useQueryParams(); 

  let userId;
  const jwt = localStorage.getItem("jwt");
  if (jwt) {
    const tokenData = decode(jwt);
    userId = tokenData.userid;
  } 
  
  if (URI_PATHS.BASIC_INFO === pathname) {
    const queryParamsEmail = queryParams.get("user");
    const email = queryParamsEmail && queryParamsEmail.toLowerCase();

    // if we have a JWT and that JWT is not the same as user email in url
    // remove JWT;
    if ((userId && jwt) && userId !== email) {
      localStorage.removeItem('jwt');
    }

    userId = email;
  }

  // state subscriptions
  const configVersion = useApplicationState("configVersion");
  const configSetWithoutUser = useApplicationState("configSetWithoutUser");

   /**
   * determine where we send users initially. 
   * Users config version is going to be determined by /getOnboardingConfig API
   * if config was grabbed without user:
   *    - config does not need to be grabbed again while we still do not have a user
   *    - this really only happens on login page where no user is known till login.
   * if config was grabbed without user and we now have a user:
   *    - config needs to be grabbed again to ensure user config is set.
   *    - config does not need to be grabbed again while we have have a user
   * 
   * config grabbed using userId will have configSetWithoutUser == False
   */
    if (!configVersion || (userId && configSetWithoutUser)) {
      dispatch(initiateOnboardingConfig({ userId }));
      return null;
    }

  const onboardingV1 = (
    <Switch>
      <Route exact path="/*" component={Onboarding} />
    </Switch>
  );

  const onboardingV2 = (
    <Switch>
      <Route exact path="/" render={() => (<Redirect to="/login" />)} />
      <Route exact path={URI_PATHS.LOGIN} component={LoginV2} />
      <Route exact path={URI_PATHS.BASIC_INFO} component={BasicInfoV2} />
      <PrivateRoute exact path={URI_PATHS.PREAPPROVAL_DASHBOARD} component={MockDashboard} />
      <PrivateRoute exact path={URI_PATHS.RELINK_BANK} component={RelinkBank}/>
      <PrivateRoute exact path="/*" component={OnboardingV2} />
    </Switch>
  );

  // Once the configVersion is set, roll with this for the rest of the time
  return configVersion === ONBOARDING_VERSION_1_0 ? onboardingV1 : onboardingV2;
};

export default RegistrationRoutes;
